// extracted by mini-css-extract-plugin
module.exports = {"scoreLabel":"GoodFuture_scoreLabel__ZTSWE"};